import React, { useEffect, useState } from 'react';

interface SMSSetupProps {
  defaultValue?: string;
  onChange?: (value: string) => void;
}

export const SMSSetup: React.FC<SMSSetupProps> = ({ defaultValue = '', onChange }) => {
  const [text, setText] = useState(defaultValue);
  const characterCount = text.length;
  const segmentCount = Math.ceil(characterCount / 160) || 1;

  useEffect(() => {
    setText(defaultValue);
  }, [defaultValue]);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value.slice(0, 130);
    setText(value);
    onChange?.(value);
  };

  return (
    <fieldset>
      <legend>SMS Text (Optional)</legend>
      <p>Only fill this out if the step is meant to include sending an SMS message</p>
      <textarea
        value={text}
        onChange={handleChange}
        rows={6}
        maxLength={130}
        placeholder="Enter SMS message text..."
      />
      <footer>
        <p>Use merge fields like {'{{First Name}}'} to personalize your message</p>
        <small>
          {characterCount}/130 characters • {segmentCount} segment
          {segmentCount !== 1 ? 's' : ''}
        </small>
      </footer>
    </fieldset>
  );
};
